<template>
    <div class="box1">
        <div class="title">补充内容</div>
        <div class="supplement">
            <van-field
                placeholder="请输入补充内容..."
                type="textarea"
                maxlength="50"
                v-model="detailContent"
            />
        </div>
        <div class="btn">
            <div class="submit">
                <van-button type="primary" @click="handleClickAdd">保存</van-button>
            </div>
            <div class="back">
                <van-button plain type="default" color="#979595" @click="$router.go(-1)">返回</van-button>
            </div>
        </div>
        <van-popup v-model="isShowPop" class="popTipsBox">
            <p class='popTips'>请先填写信息</p>
        </van-popup>
    </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis'
    import util from '../../../../utils/common'
    export default {
        data () {
            return {
                detailContent: '',
                isShowPop: false,
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                item: util.getJsonLocal('item'),
            }
        },
        methods: {
            showPop () {
                this.isShowPop = true;
            },
            handleClickAdd () {
                if (this.detailContent.trim().length === 0) {
                    this.$Toast('补充的内容不能为空');
                } else {
                    let params = {
                            mainComplainNumber: this.item.mainComplainNumber,
                            complainNumber: this.item.complainNumber,
                            subId: this.item.subId,
                            supplementContent: this.detailContent
                    }
                    api.worker.informationSupplement(params).then(res => {
                        if (res.ret == 0) {
                            this.$Toast('操作成功');
                            this.$router.back();
                        }
                    })
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .box1 {
        width: 100%;
        padding: 14px;
        background-color: #fff;
        .title {
            font-size: 14px;
            color: #999
        }
        .supplement {
            font-size: 14px;
            margin-top: 14px;
            .van-cell {
                font-size: 12px;
                background: #efeded;
                border-radius: 7px;
            }
        }
        .btn {
            margin-top: 30px;
            .van-button {
                width: 100%;
                border-radius: 7px;
                margin-top: 10px;
            }
            .back {
                .van-button {
                    color: #bdb8b8
                }
                .van-button--plain {
                    background-color: #efeded;
                }
            }
        }

        .popTipsBox{
            width: 150px;
            height: 100px;
            border-radius: 5px;

            .popTips{
                font-size: 18px;
                color: #999;
                text-align: center;
                line-height: 100px;
            }
        }
    }
</style>
